import styled from 'styled-components';

export const StyledCountryField = styled.div`
   grid-row: 3;
`;
StyledCountryField.displayName = 'StyledCountryField';
